<template>
    <div class="labelWrapper flex item-center">
        <div
            class="labelInner"
            :style="{ backgroundColor: !labelColor ? '' : labelColor }"
            :class="[classes,statusColor ? '!rounded-tr-none !rounded-br-none' : 'rounded-[0.125rem]']"
        >
            <fa v-if="prefixIcon" :icon="['fas', prefixIcon]" class="text-xs dark:text-black-900" />
            <span v-if="labelText" class="text-xs leading-[1] dark:text-black-900">{{ labelText.replace(/^0+\s*/, '') }}</span>
        </div>
        <div v-if="statusColor" class="statusInner" :style="{ backgroundColor: statusColor }">
            <fa v-if="statusIcon" :icon="['fas', statusIcon]" class="text-xs dark:text-black-900" />
            <span v-if="statusText" class="text-xs leading-[1] dark:text-black-900">{{ statusText }}</span>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    labelColor: {
        type: String,
        default: "",
    },
    labelText: {
        type: String,
        default: "",
    },
    prefixIcon: {
        type: String,
        default: "",
    },
    statusIcon: {
        type: String,
        default: "",
    },
    statusColor: {
        type: String,
        default: "",
    },
    statusText: {
        type: String,
        default: "",
    },
    classes: {
        type: String,
        default: "",
    },
});
</script>

<style>
.labelInner {
    @apply h-5 min-h-[1.25rem] flex items-center gap-1 px-2 rounded-[0.125rem] text-white;
    width: fit-content;
}
.statusInner {
    @apply h-5 min-h-[1.25rem] min-w-[1.25rem] justify-center flex items-center gap-1 px-0.5 rounded-tr-[0.125rem] rounded-br-[0.125rem] text-white;
    width: fit-content;
}
</style>
